export default {
  getCart(state) {
    return state.cart
  },
  price_total(state) {
    return state.total_price
  }
};
